export default __webpack_public_path__ + "static/media/accountstatusreject.85bfd848.svg";